import {storageFactory} from 'storage-factory';
import OKSDK from './oksdk';

const query = OKSDK.Util.getRequestParameters();
const isNotificationsEnabled = query.vk_are_notifications_enabled === 'true';
const isFirstStart = query.vk_is_app_user === 'true';

const local = storageFactory(() => localStorage);

const AppSiteType = {
  GROUP: 1,
  USER: 2,
};

const groupId = '984617390768263';
const today = new Date();

const launchState = {
  appId: '512000979455',
  appKey: 'CQPCPDKGDIHBABABA',
  appSiteKeys: {
    appSiteType: AppSiteType.GROUP,
    appSiteId: groupId,
  },
  local,
  groupId,
  getHasToken: () => {
    return Boolean(launchState.getAccessToken());
  },
  getAccessToken: () => local.getItem('accessTokenDebug1'),
  setAccessToken: (accessToken) => {
    local.setItem('accessTokenDebug1', accessToken);
  },
  getIsNotificationsEnabled: (userId) =>
    local.getItem(`isNotificationsEnabled-${userId}`) && isNotificationsEnabled,
  isNotificationsEnabled,
  isFirstStart,
  getIsSharedToday: (userId) =>
    local.getItem(
      `shared-${userId}-${today.getFullYear()}-${today.getMonth()}-${today.getDate()}`,
    ),
  setIsSharedToday: (userId, value) =>
    local.setItem(
      `shared-${userId}-${today.getFullYear()}-${today.getMonth()}-${today.getDate()}`,
      value,
    ),
  setIsNotificationsEnabled: (userId, value) => {
    local.setItem(`isNotificationsEnabled-${userId}`, value);
  },

  getUserId: () => local.getItem('userId'),
  setUserId: (value) => local.setItem('userId', value),

  vkAppId: '512000979455',
};

export default launchState;
